import Seo from "@/lib/Seo";
import PageHero from "@/components/common/PageHero";

export default function Confidentialite() {
  return (
    <>
      <Seo title="Politique de confidentialité" description="Politique de confidentialité et protection des données personnelles d'EDUCASER GROUP." path="/politique-de-confidentialite" />
      <PageHero
        breadcrumb={[{ label: "Accueil", to: "/" }, { label: "Politique de confidentialité" }]}
        title="Politique de confidentialité"
      />
      <div className="bg-white py-16 lg:py-24">
        <div className="mx-auto max-w-3xl space-y-8 px-5 text-slate-600 lg:px-8">
          <div>
            <h2 className="font-display text-xl font-bold text-brand-blue">Collecte des données</h2>
            <p className="mt-3">
              Les données collectées via nos formulaires (nom, email, téléphone, message) sont utilisées
              uniquement pour traiter vos demandes de contact, de devis, de rappel ou d'inscription.
            </p>
          </div>
          <div>
            <h2 className="font-display text-xl font-bold text-brand-blue">Utilisation des données</h2>
            <p className="mt-3">
              Vos données ne sont ni vendues ni cédées à des tiers. Elles sont conservées le temps
              nécessaire au traitement de votre demande et à la relation de formation.
            </p>
          </div>
          <div>
            <h2 className="font-display text-xl font-bold text-brand-blue">Vos droits</h2>
            <p className="mt-3">
              Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression
              de vos données. Pour l'exercer, contactez-nous à contact@educaser.fr.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
